import { render, staticRenderFns } from "./MyDefaultLayout.vue?vue&type=template&id=6afa9c20&"
import script from "./MyDefaultLayout.vue?vue&type=script&lang=ts&"
export * from "./MyDefaultLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports